import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-beneficiary-picture',
    templateUrl: './beneficiary-picture.component.html',
    styleUrls: ['./beneficiary-picture.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BeneficiaryPictureComponent {

    @Input()
    beneficiaryName: { first: string, last: string } = null;

    @Input()
    avatarSizeClassName = '-large';

    hasPictureError = false;

    constructor(private readonly cdr: ChangeDetectorRef) {
    }

    private _pictureUrl: string = null;

    get pictureUrl(): string {
        return this._pictureUrl;
    }

    @Input()
    set pictureUrl(pictureUrl: string) {
        this._pictureUrl = pictureUrl;
        this.hasPictureError = false;
        this.cdr.markForCheck();
    }

    get initial(): string {
        return ['first', 'last'].map(property => this.beneficiaryName[property]?.charAt(0) || null).join('');
    }

    handlePictureError() {
        this.hasPictureError = true;
    }
}
